import {GridColumns} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {ColorField} from 'src/components/common/ColorField';
import {UsersSortFieldEnum} from 'src/enums';
import dayjs from 'dayjs';
import {UserCell} from 'src/components/users/UserCell';
import {DeleteUser} from '../../users/DeleteUser';
import {UpdateManager} from '../../users/UpdateManager';

export const columnConfigUsers: GridColumns = [
    {
        field: 'name',
        renderHeader: (_params) => <FormattedMessage id={'memberNameColumnHeader'}/>,
        flex: 2,
        minWidth: 200,
        sortable: false,
        cellClassName: 'ampTableCell',
        renderCell: (params) => <UserCell data={params.row}/>,
    },
    {
        field: UsersSortFieldEnum.ROLE,
        renderHeader: (_params) => <FormattedMessage id={'memberRoleColumnHeader'}/>,
        flex: 2,
        minWidth: 120,
        cellClassName: 'ampTableCell',
        renderCell: (params) =>
            params.row.userType ? <ColorField label={params.row.userType}/> : '',
    },
    {
        field: UsersSortFieldEnum.EMAIL,
        renderHeader: (_params) => <FormattedMessage id={'emailColumnHeader'}/>,
        flex: 4,
        minWidth: 300,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => params.row.emailAddress,
    },
    {
        field: UsersSortFieldEnum.CREATED,
        renderHeader: (_params) => <FormattedMessage id={'createdDateColumnHeader'}/>,
        flex: 2,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => dayjs(params.row.created).format('DD/MM/YY'),
    },
    {
        field: 'lastLogin',
        renderHeader: (_params) => <FormattedMessage id={'lastLoginColumnHeader'}/>,
        flex: 2,
        minWidth: 100,
        sortable: false,
        cellClassName: 'ampTableCell',
        valueGetter: (params) =>
            params.row.lastLogin ? dayjs(params.row.lastLogin).format('DD/MM/YY') : '-',
    },
    {
        field: 'actions',
        width: 120,
        headerName: '',
        sortable: false,
        cellClassName: 'ampTableCell',
        align: 'right' as const,
        headerAlign: 'right' as const,
        renderCell: (params) => params.row.business && (
            <>
                <UpdateManager row={params.row}/>
                <DeleteUser row={params.row}/>
            </>
        ),
    },
];
